import axios from '../../plugins/axios';

export const listBusiness = ({ commit }, { params }={}) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` },
    params
  }
  return axios.get('/api/business', config)
    .then((response) => {
      const businesses = response.data;
      commit('SET_BUSINESSES', { businesses })
    },
    (error) => {
      console.log(error);
    })
};

export const listActiveBusiness = ({ commit }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get('/api/business/active', config)
    .then((response) => {
      const businesses = response.data;
      commit('SET_BUSINESSES', { businesses })
    },
    (error) => {
      console.log(error);
    })
};

export const editBusiness = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/business/${data.id}`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
};

export const deleteBusiness = ({}, id) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.delete(`/api/business/${id}`, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const createBusiness = ({}, data) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.post('/api/business', data, config)
    .then((response) => response )
    .catch((error) => error.response );
}

export const getBusiness = ({commit}, id) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/business/${id}`, config)
    .then((response) => {
      const business = response.data.business;
      commit('SET_BUSINESS', { business })
    },
    (error) => {
      console.log(error);
    })
}

export const listBusinessFromService = ({commit}, id) => {
  commit('SET_BUSINESSES', { businesses: [] })
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/service/${id}/business`, config)
    .then((response) => {
      const businesses = response.data;
      commit('SET_BUSINESSES', { businesses })
    },
    (error) => {
      console.log(error);
    })
}

export const listBusinessServices = ({commit}, { serviceId }) => {
  commit('SET_BUSINESS_SERVICES', [])
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.get(`/api/service/${serviceId}/business-service`, config)
    .then((response) => {
      commit('SET_BUSINESS_SERVICES', response.data)
    },
    (error) => {
      console.log(error);
    })
}

export const updateBusinessReminder = ({}, { id, reminder }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.patch(`/api/business/${id}/reminder`, { reminder }, config)
    .then((response) => response)
    .catch((error) => error.response);
}